export default __webpack_public_path__ + "static/media/fcv-insurance.b1a084dd.svg";